export class MonologueManager {
  public text: string = "";
}
